import { render, staticRenderFns } from "./RankingProductList.vue?vue&type=template&id=2ad273ef&scoped=true&"
import script from "./RankingProductList.vue?vue&type=script&lang=js&"
export * from "./RankingProductList.vue?vue&type=script&lang=js&"
import style0 from "./RankingProductList.vue?vue&type=style&index=0&id=2ad273ef&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad273ef",
  null
  
)

export default component.exports